// Module
var code = "<!--ko if: Visible--> <div class=\"btn-group back-button\"> <button type=\"button\" class=\"btn btn-primary\" data-bind=\"click: Click\"> <i class=\"fa fa-angle-left\"></i> <!--ko text: _labels.BACK --><!--/ko--> </button> </div> <!--/ko-->";
// Exports
export default code;